import { useCallback, useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ToastProvider } from '@monigo/ui';
import { router } from './router.js';
import { useSession } from '../lib/store/session.js';
import { SplashScreen } from '../components/Splash/SplashScreen.js';

export function App() {
  const init = useSession((s) => s.init);
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    void init();
  }, [init]);

  const handleSplashFinish = useCallback(() => {
    setShowSplash(false);
  }, []);

  return (
    <>
      {showSplash ? <SplashScreen onFinish={handleSplashFinish} /> : null}
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </>
  );
}
